import { useCallback } from 'react';
import { Switch, SwitchProps } from '@antimatterhq/ui/components/switch';

export type FormSwitchProps = {
  name: string;
  onChange?: React.FormEventHandler<HTMLInputElement>;
  onBlur?: React.FocusEventHandler<HTMLInputElement>;
} & SwitchProps;

export const FormSwitch = ({
  name,
  checked,
  onChange,
  onBlur,
  ...props
}: FormSwitchProps) => {
  const handleChange = useCallback(
    (value: boolean) => {
      onChange?.({
        target: {
          name,
          value,
        },
      } as unknown as React.ChangeEvent<HTMLInputElement>);
    },
    [onChange, name],
  );

  return (
    <Switch
      name={name}
      checked={checked}
      onCheckedChange={handleChange}
      onBlur={onBlur}
      {...props}
    />
  );
};
